export default class TrackingState {
  constructor(contextType, contextId, options = {}) {
    this.contextType = contextType;
    this.contextId = contextId;
    this.brickId = options.brickId;
    this.inWidget = options.inWidget;

    this.listItemContextType = options.listItemContextType;
    this.listItemContextId = options.listItemContextId;
    this.contextTitle = options.contextTitle;

    this.setDefaultOptions(options);
  }

  setContextTitle(title) {
    this.contextTitle = title;
  }

  setDefaultOptions(options) {
    const defaultTrackingOptions = { ...options.defaultTrackingOptions };

    // Don't just use $.extend here, since category might be set in the
    // defaultTrackingOptions, but undefined in the brickData. The brickData
    // in that case will take precedence, which is incorrect.
    this.listId = defaultTrackingOptions.listId || options.listId;
    this.listItemId = defaultTrackingOptions.listItemId || options.listItemId;
    this.categoryId = defaultTrackingOptions.categoryId || options.categoryId;
    this.campaign = defaultTrackingOptions.campaign || options.campaign;

    this.medium = defaultTrackingOptions.medium || options.medium || 'brick';
    this.mediumContext = defaultTrackingOptions.mediumContext || options.mediumContext || 'unset';
  }

  toTrackingOptions() {
    return {
      contextType: this.contextType,
      contextId: this.contextId,
      contextTitle: this.contextTitle,

      brickId: this.brickId,
      campaign: this.campaign,
      inWidget: this.inWidget,
      medium: this.medium,
      mediumContext: this.mediumContext,
      categoryId: this.categoryId,

      listId: this.listId,
      listItemId: this.listItemId,
      listItemContextType: this.listItemContextType,
      listItemContextId: this.listItemContextId,
    };
  }
}



// WEBPACK FOOTER //
// ./~/gwi-tracker/src/tracking-state.js